import { AxiosInstance } from 'axios';
import { toResponse } from '../../genericToResponse';

interface ICredentials {
  email: string;
  password: string;
  code: string;
}

export default (api: AxiosInstance, url: string) => async ({
  email,
  password,
  code,
}: ICredentials) => {
  const response = await api.post(url, {
    Email: email,
    Password: password,
    Code: code,
  });
  return toResponse(response.data);
};



// WEBPACK FOOTER //
// ./src/services/api/user/passwordChange/reset.ts